import React, { useEffect, useState } from 'react';
import { v2_all_user } from '../../actions/v2/user';
import { v3_assign_claim } from '../../actions/v3/guaranteeClaims';
import { toast } from 'react-toastify';
import constant from '../../constant';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const AssignUser = ({ claimId, onSaveAssignee, loading, setLoading }) => {
    const [users, setUsers] = useState([]);
    const [assignedUsers, setAssignedUsers] = useState([]);

    useEffect(() => {
        v2_all_user().then((res) => {
            if (res.status) {
                setUsers(res.result);
            }
        });
    }, []);



    return (
        <React.Fragment>

            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">Assignee Details</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" />
                </div>

                <div className="modal-body">
                    <div className="table-responsive">
                        <table className="table align-middle table-nowrap table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Role</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users.map((user) => {
                                    const isChecked = assignedUsers.includes(String(user.USER_ID));
                                    return (
                                        <tr key={user.USER_ID}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    onChange={() => {
                                                        const userId = String(user.USER_ID);
                                                        setAssignedUsers((prev) =>
                                                            isChecked
                                                                ? prev.filter((id) => id !== userId)
                                                                : [...prev, userId]
                                                        );
                                                    }}
                                                />
                                            </td>
                                            <td>{user.FULL_NAME}</td>
                                            <td>{user.ROLE_NAME}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <button
                                className="btn btn-success"
                                onClick={() => onSaveAssignee(users.map((item) => item.USER_ID))}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
};

export default AssignUser;
